import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { AuthState, TeamMember } from './types';

import { mapGroups, mapTeamMembers } from '@/utils/formatUserGroups';
import { getAvatarColor } from '@/utils';

const getters: GetterTree<AuthState, RootState> = {
  getAuthenticated: (auth: AuthState): boolean => auth.authenticated || false,
  getUser: (auth: AuthState): object => auth.user,
  getUserGroups: (auth: AuthState): object[] => {
    const { user: { groups = [] } = {} } = auth;
    return mapGroups(groups);
  },
  getUserTeam: (auth: AuthState): object[] => [...mapTeamMembers(auth.user.team)],
  getUserFullTeam: (auth: AuthState): object[] => {
    const selfUser = {
      ...auth.user,
      avatarColor: getAvatarColor(),
      name: `${auth.user.firstName} ${auth.user.lastName}`,
      avatarName: auth.user.firstName[0] + auth.user.lastName[0]
    };
    return [selfUser, ...mapTeamMembers(auth.user.team)];
  }
};

export default getters;
